// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__2yQP6","resendInfoText":"OnGoingPaymentBox_resendInfoText__23z2T"};